import { Usage } from 'entities/usage';
import { ViewModel } from 'view_models';

export class UsageViewModel extends ViewModel<Usage> {
  public getStartedAtText(): string {
    return this.object.startedAt ? this.timestampToDatetimeText(this.object.startedAt) : '';
  }

  public getEndedAtText(): string {
    return this.object.endedAt ? this.timestampToDatetimeText(this.object.endedAt) : '';
  }

  public getPeriodText(): string {
    return `${this.getStartedAtText()} 〜 ${this.getEndedAtText()}`;
  }

  public getUserName(): string {
    return this.object.userName || '';
  }

  public getContent(): string {
    return this.object.content || '';
  }
}
